export function getCookie(name) {
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(encodeURIComponent(name).replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1'), "=([^;]*)")));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
export function setCookie(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cookieOptions = Object.assign({
    path: '/',
    secure: true
  }, options);
  var updatedCookie = "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value));
  Object.keys(cookieOptions).forEach(function (optionKey) {
    updatedCookie += "; ".concat(optionKey);
    var optionValue = cookieOptions[optionKey];

    if (optionValue !== true) {
      updatedCookie += "=".concat(optionValue);
    }
  });
  document.cookie = updatedCookie;
}
export function removeCookie(name) {
  setCookie(name, '', {
    'max-age': -1
  });
}
export function getCookieKeys() {
  var cookies = document.cookie.split(';');
  var res = [];
  cookies.forEach(function (cookie) {
    var key = cookie.trim().split('=')[0];

    if (key) {
      res.push(decodeURIComponent(key));
    }
  });
  return res;
}